const domIds = new Set();

domIds
    .add('login-button-desktop')
    .add('login-success-desktop')
    .add('header-logout-desktop')
    .add('login-button-mobile')
    .add('login-success-mobile')
    .add('header-logout-mobile')
    .add('hotel-standalone-search-form-mobile-menu_click')
    .add('hotel-standalone-search-form-desktop-menu_click')
    .add('home-dp-load-search-form')
    .add('home-dp-search-destination')
    .add('home-dp-search-departure')
    .add('home-dp-search-destination-no-match')
    .add('home-dp-search-departure-no-match')
    .add('home-dp-search-dates')
    .add('home-dp-search-rooms')
    .add('home-dp-search')
    .add('home-dp-search_error')
    .add('home-flights-dp-search')
    .add('home-dp-search-form-desktop-tab_click')
    .add('home-hotel-standalone-search-form')
    .add('home-hotel-standalone-search')
    .add('home-hotel-standalone-search_error')
    .add('home-hotel-standalone-search-destination')
    .add('home-hotel-standalone-search-destination_error')
    .add('home-hotel-standalone-search-dates')
    .add('home-hotel-standalone-search-dates_error')
    .add('home-hotel-standalone-search-rooms')
    .add('home-hotel-standalone-search-destination-no-matches')
    .add('home-hotel-standalone-search-destination-loading-results')
    .add('home-hotel-standalone-search-form-desktop-tab_click')
    .add('home-hotel-standalone-search-destination-type-in')
    .add('home_hotels-home_search-extension')
    .add('home-hotel-standalone-search-form-desktop-tab_preselected')
    .add('home-hotel-standalone-search-popular-destination')
    .add('home-hotel-standalone-search-popular-destination_click')
    .add('home-hotel-standalone-search-form-wizard-skeleton')
    .add('home-home')
    .add('home-home_flights')
    .add('home-home_dp')
    .add('home-home_hotels_organic')
    .add('home-home_hotels_search_extension')
    .add('home-error-boundary');

export default domIds;
